export default {"src":"/_next/static/media/arugula.2fe38e3a.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};